'use client';

import React, { useRef, useState } from 'react';

import clsx from 'clsx';
import { useClickAway } from 'react-use';

import styles from './styles.module.css';

import { PlaceholderPills } from '@/app/[locale]/(browse)/components/PlaceholderPills';
import { SubMenu } from '@/components/MobileNavigation/SubMenu';
import { Pill } from '@/components/Pill';
import { PlaceHolderShape } from '@/components/Placeholder';
import {
  ActivityTrackerEventType,
  HomePageModuleNames,
} from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useNavConfig } from '@/modules/meganav/useNavConfig';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function ProductCategories() {
  const { config, isLoading } = useNavConfig();
  const [, currentUser] = useCurrentUser();
  const subMenuContainerRef = useRef<HTMLDivElement>(null);
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId: currentUser?.id,
  });

  const subMenuItems =
    config.find((item) => item.label === activeCategory)?.contentCollection
      .items || [];

  const isSubMenuOpen = Boolean(
    subMenuItems?.length && activeCategory !== null
  );

  useClickAway(subMenuContainerRef, () => {
    if (isSubMenuOpen) {
      setActiveCategory(null);
    }
  });

  if (isLoading) {
    return (
      <div className={styles.placeholderPillsWrapper}>
        <PlaceholderPills shape={PlaceHolderShape.PILL} />
      </div>
    );
  }

  function handleListItemClick(label: string) {
    setActiveCategory(label);
    sendActivityTrackerEvent(ActivityTrackerEventType.MODULE_CLICK_ACTION, {
      moduleName: HomePageModuleNames.CategoryPills,
      itemClicked: label,
      schemaVersion: '3.0',
    });
  }

  return (
    <div className={styles.pillContainer}>
      <div className={styles.pillList}>
        {config.map((item) => (
          <Pill
            variant="light"
            key={item.label}
            onClick={() => handleListItemClick(item.label)}
            isActive={item.label === activeCategory}
          >
            {item.label}
          </Pill>
        ))}
      </div>
      <div
        className={clsx(styles.subMenuContainer, {
          [styles.subMenuContainer__isOpen]: isSubMenuOpen,
        })}
        ref={subMenuContainerRef}
      >
        <SubMenu
          isOpen={isSubMenuOpen}
          closeMenu={() => setActiveCategory(null)}
          onBackClick={() => setActiveCategory(null)}
          items={subMenuItems}
          title={activeCategory || ''}
          focusOnOpen
        />
      </div>
    </div>
  );
}
